import React, {Fragment} from "react";
import htmlParser from "he";
import {personalizeResponse} from "_helpers";
import moment from "moment-timezone";
import ProactiveMetricsMessageIframe from "./Utilities/ProactiveMetricsMessageIframe";
import styles from "./Utilities/styles.module.css";

const RetainConversationBox = ({message, index, source}) => {
    const messageAuthor = message?.authorName;
    const zone_name =  moment.tz.guess();
    const timezone = moment.tz(zone_name).zoneAbbr();
    const dateCreated =  message?.dateCreatedFromSource || message?.dateCreated;
    const text = htmlParser.decode(personalizeResponse(message.text, messageAuthor, "", null));

    return(
        <Fragment>
            <div className={styles.conversationContainer}>
                <div className="retain-md-msg-container">
                    <div className="conversation-item-container">
                        <div className="conversation-item-row">
                            <div className={`${styles.retainHeader} ${index > 0 ? styles.retainHeader_plf : ''}`} >
                                <div className={styles.retainConvoBoxHeading}>
                                    {index === 0 && "CONVERSATION"}
                                </div>
                                <div className={styles.retainMetricsDetailDateTime}>
                                    <span className="metrics-detail-date retain-metrics-detail-date">
                                        {`${moment(dateCreated).format('MMMM Do YYYY HH:mm')} ${timezone}`}
                                    </span>
                                </div>
                            </div>
                            <div
                                className={`${styles.retainMetricsDetailFullMsg} ${
                                    index > 0 ? styles.retainMetricsDetailFullMsg_plh : ''
                                } ${
                                    message.direction.toLowerCase() === "outgoing" ? styles.retainOutgoingMsg : ''
                                }`}
                            >
                                <ProactiveMetricsMessageIframe text={text} index={index} messageSource={source}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default RetainConversationBox;